import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../leaf-element.js";
import { LeafIcon } from "../icon/icon.component.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --color-facebook: #4267b2;\n  --color-twitter: #1da1f2;\n  --color-linkedin: #2867b2;\n  --color-youtube: #ff0000;\n  --color-instagram: #f00073;\n}\n\n.leaf-c-social-link {\n  border-radius: var(--leaf-border-radius-round);\n  color: var(--leaf-color-footer-bg-secondary);\n  display: inline-flex;\n  font-size: 1rem;\n  padding: var(--leaf-spacing-8);\n}\n\n.leaf-c-social-link--facebook {\n  background: var(--color-facebook);\n}\n\n.leaf-c-social-link--twitter {\n  background: var(--color-twitter);\n}\n\n.leaf-c-social-link--linkedin {\n  background: var(--color-linkedin);\n}\n\n.leaf-c-social-link--youtube {\n  background: var(--color-youtube);\n}\n\n.leaf-c-social-link--instagram {\n  background: var(--color-instagram);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafSocialLink = class _LeafSocialLink extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.target = "_blank";
  }
  get networkLink() {
    const networks = {
      facebook: `https://www.facebook.com/${this.profile}/`,
      twitter: `https://twitter.com/${this.profile}`,
      linkedin: `https://www.linkedin.com/company/${this.profile}`,
      youtube: `https://www.youtube.com/channel/${this.profile}`,
      instagram: `https://www.instagram.com/${this.profile}/`
    };
    return networks[this.network];
  }
  get iconName() {
    if (this.network === "linkedin") {
      return "linkedin-in";
    }
    return this.network;
  }
  render() {
    const componentClassName = {
      "leaf-c-social-link": true,
      [`leaf-c-social-link--${this.network}`]: true
    };
    return html`<a
      part="base"
      class=${classMap(componentClassName)}
      target="${this.target}"
      href="${this.networkLink}"
      data-element-text="${this.iconName}"
    >
      <leaf-icon part="icon" set="social" name="${this.iconName}" label="${this.label || this.network}"></leaf-icon>
    </a>`;
  }
};
_LeafSocialLink.styles = unsafeCSS(styles);
_LeafSocialLink.elementDefinitions = {
  "leaf-icon": LeafIcon
};
let LeafSocialLink = _LeafSocialLink;
__decorateClass([
  property()
], LeafSocialLink.prototype, "network", 2);
__decorateClass([
  property()
], LeafSocialLink.prototype, "profile", 2);
__decorateClass([
  property()
], LeafSocialLink.prototype, "label", 2);
__decorateClass([
  property()
], LeafSocialLink.prototype, "target", 2);
export {
  LeafSocialLink
};
//# sourceMappingURL=social-link.component.js.map
